module.exports = __webpack_public_path__ + "media/images/advertiser-chart-aa34b779baf654c5d599c6d67e77ec31.svg";